import {Component, Input, OnInit, TemplateRef, ViewChild} from '@angular/core';
import { BnLoadingService, EntityOrderedRequestParameters } from "@bndes/bndes-ux4/bndes-angular-utils";
import { TipoPagamentoEcgTerceiro } from '../../../model/tipo-pagamento-ecg-terceiro';
import { TipoPagamentoEcgTerceiroService } from '../../contratacao/operacao/tipo-pagamento-ecg-terceiro.service';
import {BnModalMessageService} from '@bndes/bndes-ux4/bn-modal-message';
import {BnAlertsService} from '@bndes/bndes-ux4/bn-alerts';
import Utils from '../../../shared/fgi-utils';

@Component({
  selector: 'app-ecg-por-terceiros-listagem',
  templateUrl: './ecg-por-terceiros-listagem.component.html',
  styleUrls: ['./ecg-por-terceiros-listagem.component.scss'],
  standalone: false
})
export class EcgPorTerceirosListagemComponent implements OnInit{

  @Input() public ecgTerceirosPesquisado: TipoPagamentoEcgTerceiro[];
  public atributosOrdenacao: EntityOrderedRequestParameters;
  public idEcgTerceiroPesquisadoSelecionado: number;
  @Input() public filtroBusca: any = {};


  @ViewChild('msgTemplateExcluir') msgTemplateExcluir: TemplateRef<any>;
  @ViewChild('botoesPersonalizadosExcluir') botoesPersonalizadosExcluir: TemplateRef<any>;


  constructor(
    private bnModalService: BnModalMessageService,
    private loadingService: BnLoadingService,
    private alertsService: BnAlertsService,
    private tipoPagamentoEcgTerceiroService: TipoPagamentoEcgTerceiroService,) {

  }

  ngOnInit() {
    this.atributosOrdenacao = {
      atributo: '',
      sentido: 'asc'
    }
  }


  mudancaOrdenacao(novaOrdenacao: EntityOrderedRequestParameters) {
    this.atributosOrdenacao = novaOrdenacao;
    this.pesquisarOrdenacao(this.atributosOrdenacao);
  }

  pesquisarOrdenacao(ord: EntityOrderedRequestParameters) {
    let funcao = undefined;
    if (ord.atributo == 'valor') {
      funcao = parseFloat;
    }
    this.ecgTerceirosPesquisado = this.ecgTerceirosPesquisado.sort((a, b) => {
      if (ord.sentido == 'asc') {
        return Utils.comparaComFuncao(a, b, ord.atributo, funcao);
      } else {
        return -1 * Utils.comparaComFuncao(a, b, ord.atributo, funcao);
      }
    });
  }

  modalConfirmarExclusao(id: number, usoEmOperacao: boolean) {

    if (!usoEmOperacao) {

      this.idEcgTerceiroPesquisadoSelecionado = id;

      this.bnModalService.abrir(
        'Confirmação',
        'Confirma a exclusão?',
        'lg',
        this.msgTemplateExcluir,
        this.botoesPersonalizadosExcluir
      );

    }

  }

  excluir() {

    if (this.idEcgTerceiroPesquisadoSelecionado && this.idEcgTerceiroPesquisadoSelecionado != undefined) {

       this.loadingService.bloqueiaTela();
       this.tipoPagamentoEcgTerceiroService.excluirTipoPagamentoEcgTerceiro(this.idEcgTerceiroPesquisadoSelecionado).subscribe({
        next: () => {
          this.chamarAtualizacaoListagemComFiltro();
          this.loadingService.liberaTela();
          this.alertsService.alertaSucesso("Sucesso", `Produto ${this.idEcgTerceiroPesquisadoSelecionado} excluído com sucesso.`);
          this.bnModalService.dismiss();
        },
        error: () => {
          this.loadingService.liberaTela();
          this.alertsService.alertaErro("Erro", "Erro ao excluir produto.");
          this.bnModalService.dismiss();
        }
      })

    }
  }

  dismissModal() {
    this.bnModalService.dismiss();
  }

  chamarAtualizacaoListagemComFiltro(){

    this.tipoPagamentoEcgTerceiroService.buscarFiltradoTipoPagamentoEcgTerceiro(this.filtroBusca).subscribe(res => {
      this.ecgTerceirosPesquisado = res;

    });

  }


}
